import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { sortObjectsByAlphabet } from "../../../utils";
import ModalListTable from "../../../view/ModalListTable";

export function EditTargetTypeModal({ setShowModal, elements = [], onClick, title, text, onBack }) {

    const sortedElements = sortObjectsByAlphabet(elements, "name");

    const columns = [
        {
            key: "name",
            label: text,
            className: "target-type-picker-modal__name",
            searchValue: (element) => element.name,
            render: (element) => element.name
        },
        {
            key: "actions",
            label: "Actions",
            className: "target-type-picker-modal__actions",
            headerClassName: "target-type-picker-modal__actions",
            render: (element) => (
                <button
                    type="button"
                    className="oct_modal-list__action-btn oct_modal-list__action-btn--text"
                    onClick={(event) => {
                        event.stopPropagation();
                        onClick(element);
                    }}
                >
                    Select
                </button>
            )
        }
    ];

    return (
        <div className="modal oct_display-block modal-v2-root">
            <div className="modal oct_modal modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog target-type-picker-modal" aria-modal="true">
                    <div className="modal-content modal-v2-shell target-type-picker-modal">
                        <div className="modal-v2-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading">{title}</h2>
                                    <p className="target-type-picker-modal__subtitle">{text}</p>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="modal-v2-close"
                                aria-label="Close"
                                onClick={() => setShowModal(false)}
                            >
                                <span aria-hidden="true"><CloseIcon /></span>
                            </button>
                        </div>
                        <div className="modal-body modal-v2-body target-type-picker-modal__body">
                            <ModalListTable
                                items={sortedElements}
                                columns={columns}
                                variant="schedule"
                                searchPlaceholder="Search..."
                                emptyMessage="No entries found."
                                noResultsMessage="No matching entries found."
                                getSearchValue={(element) => element.name || ""}
                                onRowClick={onClick}
                                hideHeaderWhenEmpty={true}
                                hidePaginationWhenEmpty={true}
                            />
                        </div>
                        <div className="modal-footer modal-v2-footer target-type-picker-modal__footer">
                            <div className="modal-v2-footer-note"></div>
                            <div className="modal-v2-footer-actions">
                                {typeof onBack === "function" ? (
                                    <button
                                        type="button"
                                        className="modal-v2-btn modal-v2-btn-outline"
                                        onClick={onBack}
                                    >
                                        Back
                                    </button>
                                ) : null}
                                <button
                                    type="button"
                                    className="modal-v2-btn modal-v2-btn-outline"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
